import React, { Component } from "react";
import moment from "moment";
import CircularJSON from "circular-json";
import InputLabel from "@material-ui/core/InputLabel";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Fade from "@material-ui/core/Fade";
import Grid from "@material-ui/core/Grid";
import { DatePicker } from "@material-ui/pickers";
import { DropzoneDialog } from "material-ui-dropzone";
import NuxeoClient from "../../clients/NuxeoClient";
import CommonContants from "../../constants/CommonConstants";
import ArrayUtils from "../../utils/ArrayUtils";
import StringUtils from "../../utils/StringUtils";
import EventUtils from "../../utils/EventUtils";
import Snackbar from "@material-ui/core/Snackbar";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import InfoIcon from "@material-ui/icons/Info";
import TextareaAutosize from "@material-ui/core/TextareaAutosize";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import DeleteIcon from "@material-ui/icons/Delete";
import Tooltip from "@material-ui/core/Tooltip";
import Loading from "../../components/loading/Loading";
import Licensee from "../inputs/Licensee";
import Contract from "../inputs/Contract";
import Territories from "../inputs/Territories";
import Property from "../inputs/Property";
import TierOfDistribution from "../inputs/TierOfDistribution";
import Retailer from "../inputs/Retailer";
import ConsumerTarget from "../inputs/ConsumerTarget";
import AssociatedJobs from "../inputs/AssociatedJobs";
import ProductDetail from "../inputs/ProductDetail";
import AssetFileName from "../inputs/AssetFileName";
import Characters from "../inputs/Characters";
import Loads from "../../components/loading/load";
import { FavMenu } from "../ui/FavMenu";
import { JobLoadingModal } from "../ui/Modals";
import { GAPageView } from "../..";
import ReactGA from "react-ga";
import "./MarketingSubmissionFields.css";
import Channel from "../inputs/Channel";
import { I18nContext } from "../../I18nProvider";

export class MarketingSubmissionFields3 extends Component {
  static contextType = I18nContext;

  constructor(props) {
    super(props);

    //Defain the component state
    this.state = {
      isHidden: true,
      isUploading: false,
      isUploadingSupportingFiles: false,
      isLoading: true,
      showSubmit: true,
      isSubmitting: false,
      selectedDate: new Date(),
      requiredFields: [
        "licensee",
        "contract",
        "territories",
        "property",
        "tierOfDistribution",
        "marketingChannel",
        "inMarketStartDate",
        "additionalNotes",
        "productDetail",
        "assetFileName",
        "characters",
        "files",
        "wbcpContact",
      ],
      count: 0,
      isSelectAll: false,
      isClear: false,

      licensee: null,
      licenseeID: null,
      licenseePath: null,
      licenseeCode: null,
      contract: "",
      contractID: null,
      territories: [],
      territoriesID: [],
      property: "",
      propertyID: null,
      tierOfDistribution: [],
      retailer: [],
      consumerTarget: [],
      marketingChannel: "",
      marketingChennalID: null,
      onShelfDate: null,
      inMarketStartDate: null,
      inMarketEndDate: null,
      productTitle: "",
      additionalNotes: "",
      associatedJobs: [],
      licenseeRef: null,
      productDetail: "",
      productDetailID: null,
      wbcpContact: null,
      assetFileName: [],
      assetFileID: null,
      originalAssetsUID: [],
      originalAssetsParentRef: [],
      characters: [],
      charactersID: [],
      text: null,
      name: [],

      //dropzone state variables
      supportingFilesOpen: false,
      filesOpen: false,
      files: [],
      supportingFiles: [],
      filesBatch: [],
      supportingFilesBatch: [],
      showPreviews: true,
      showPreviewsInDropzone: true,
      showAlerts: true,
      completedFields: [],

      //data-fetching state variables
      fetchedLicensees: [],
      fetchedProperty: [],
      fetchedMarketingChannels: [],
      fetchedAssetFileNames: [],
      fetchedCharacters: [],
      fetchedAssetFileCharacters: [],
      fetchedAssociatedJobs: [],

      //snackbar
      openSnackMsg: false,
      snackBarMsg: "Sample Msg",

      assetFilesLoading: false,
      isJobInfoLoading: false,
      isFavorite: false,
      favoriteName: null,
      job: null,
      browserLang: "en-US",
    };
    this.temp = [];
    this.docPrefix = "mkg";
    this.docType = "SubmissionMarketing";
    this.document = null;

    this.handleChange = this.handleChange.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
    this.handleClearAllClick = this.handleClearAllClick.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleOpen = this.handleOpen.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleSnackMsgClose = this.handleSnackMsgClose.bind(this);
    this.handleSingleChipDelete = this.handleSingleChipDelete.bind(this);
    this.setJobInfo = this.setJobInfo.bind(this);
  }

  //fetching dropdown data from Nuxeo
  async componentDidMount() {
    // Date Localization
    const lang = navigator.language || navigator.userLanguage;
    if (lang && lang.toLowerCase().startsWith("ja")) {
      this.setState({ browserLang: "ja-JP" });
    } else {
      this.setState({ browserLang: "en-US" });
    }

    await this._createEmptyDoc();

    GAPageView("Marketing Submission Form");

    //Hide the progress bar
    this.setState({ isLoading: false });
  }

  async setJobInfo(jobInfo) {
    this.setState({ isJobInfoLoading: true });
    this.clearValues();

    this.setState({ job: jobInfo });
    this.setState({ contractID: jobInfo["submission:contract"] });
    await this._getInfoById(jobInfo["submission:contract"]).then((res) =>
      this.setState({ contract: res.title }, () =>
        this._checkFieldChange("contract")
      )
    );
    this.setState({ territoriesID: jobInfo["submission:territories"] });
    await jobInfo["submission:territories"].forEach((territory, index) => {
      this._getInfoById(territory).then((response) => {
        // console.log("res", response);
        let territories = [...this.state.territories];
        territories.push(response.title);
        this.setState({ territories });
      });
    });

    this.setState({ propertyID: jobInfo["submission:property"] });
    this._getInfoById(jobInfo["submission:property"]).then((response) => {
      this.setState({ property: response.title }, () =>
        this._checkFieldChange("property")
      );
    });

    this.setState({ associatedJobsID: jobInfo["submission:associatedJobs"] });
    jobInfo["submission:associatedJobs"].forEach((id) => {
      this._getInfoById(id).then((response) => {
        let associatedJobs = [...this.state.associatedJobs];
        associatedJobs.push(response.title);
        this.setState({ associatedJobs });
      });
    });

    var product = jobInfo["mkg_submission:product"][0];

    this.setState({
      originalAssetsUID: product[this.docPrefix + "_originalAssets"],
    });
    product[this.docPrefix + "_originalAssets"].forEach((asset) => {
      this._getInfoById(asset).then((response) => {
        var assetsArray = [...this.state.assetFileName];
        assetsArray.push(response.title);
        this.setState({ assetFileName: assetsArray });
      });
    });

    this.setState({ charactersID: product[this.docPrefix + "_characters"] });
    product[this.docPrefix + "_characters"].forEach((character) => {
      this._getInfoById(character).then((response) => {
        var charactersArray = [...this.state.characters];
        charactersArray.push(response.title);
        this.setState({ characters: charactersArray });
      });
    });

    this.setState({
      productDetailID: product[this.docPrefix + "_productDetail"],
    });
    this._getInfoById(product[this.docPrefix + "_productDetail"]).then(
      (response) => this.setState({ productDetail: response.title })
    );

    this.state.fetchedMarketingChannels.forEach((data) => {
      if (data.id === jobInfo["mkg_submission:deliveryTypeMkg"]) {
        this.setState({ marketingChannel: data.label });
      }
    });

    // todo: figure out what this block is doing
    this.setState({
      tierOfDistribution: jobInfo["submission:tierOfDistribution"],
      retailer: jobInfo["submission:retailer"],
      consumerTarget: jobInfo["submission:consumerTarget"],
      onShelfDate: jobInfo["submission:inMarketDate"],
      productTitle: jobInfo["dc:description"],
      additionalNotes: jobInfo["submission:notes"],
      text: product["mkg_assetTextVerbiage"],
      licenseeRef: jobInfo["submission:internalRefId"],
      inMarketStartDate: jobInfo["mkg_submission:programBegin"],
      inMarketEndDate: jobInfo["mkg_submission:programEnd"],
      wbcpContact: jobInfo["mkg_submission:wbcpContact"],
    });

    setTimeout(() => {
      this.setState({
        isJobInfoLoading: false,
      });
    }, 5000);
  }

  async _getInfoById(id, index = null) {
    var response;

    await NuxeoClient.instance()
      .getJobInfo(id)
      .then((res) => {
        response = res;
      });
    response.index = index;

    return response;
  }

  async _createEmptyDoc() {
    await NuxeoClient.instance()
      .fetchDocument(this.docType)
      .then((response) => {
        this.document = response;
      });
  }

  async _loadassetFileCharacters() {
    await NuxeoClient.instance()
      .fetchAssetCharacters(this.state.assetFileID)
      .then((response) => {
        if (response.length === 0) return;

        if (this.state.fetchedAssetFileCharacters.length > 0) {
          const character = response.filter(
            (b) =>
              !this.state.fetchedAssetFileCharacters.some(
                (a) => a.item.displayLabel === b.item.displayLabel
              )
          );
          character.forEach((res) => {
            this.setState((prevstate) => ({
              fetchedAssetFileCharacters:
                prevstate.fetchedAssetFileCharacters.concat(res),
              characters: prevstate.characters.concat(res.item.displayLabel),
            }));
          });
        } else {
          response.forEach((res) => {
            this.setState((prevstate) => ({
              fetchedAssetFileCharacters:
                prevstate.fetchedAssetFileCharacters.concat(res),
              characters: prevstate.characters.concat(res.item.displayLabel),
            }));
          });
        }
      });
  }

  clearValues() {
    this.setState({
      contract: "",
      contractID: null,
      territories: [],
      territoriesID: [],
      property: "",
      propertyID: null,
      tierOfDistribution: [],
      retailer: [],
      consumerTarget: [],
      marketingChannel: "",
      onShelfDate: null,
      inMarketStartDate: null,
      inMarketEndDate: null,
      productTitle: null,
      additionalNotes: null,
      associatedJobs: [],
      associatedJobsID: [],
      marketingChennalID: null,
      licenseeRef: null,
      productDetail: "",
      productDetailID: null,
      assetFileName: [],
      originalAssetsUID: [],
      originalAssetsParentRef: [],
      characters: [],
      charactersID: null,
      text: "",
      name: [],
    });
  }

  // handles when values are picked or typed
  handleChange = (name) => (event) => {
    this.setState(
      {
        [name]: event.target.value,
      },
      () => this._checkFieldChange(name)
    );
  };

  handleInputChange = (name, value) => {
    this.setState(
      {
        [name]: value,
      },
      () => this._checkFieldChange(name)
    );
  };

  handleAssets = (name, value) => {
    this.setState(
      {
        [name]: value,
      },
      () => this._checkFieldChange(name)
    );
  };

  handleFav = (name, value) => {
    this.setState({
      [name]: value,
    });
  };

  _checkFieldChange(name) {
    //handel Licensee Change
    if (name === "licenseeCode") {
      this.clearValues();
    }

    if (name === "contractID") {
      if (!this.state.isJobInfoLoading) {
        this.setState({
          territories: [],
          territoriesID: [],
          property: "",
          propertyID: null,
          productDetail: "",
          productDetailID: null,
          assetFileName: [],
          originalAssetsUID: [],
          characters: [],
          charactersID: [],
        });
      }
    }

    if (name === "propertyID") {
      this.setState({
        assetFileName: [],
        originalAssetsParentRef: [],
        originalAssetsUID: [],
        characters: [],
        charactersID: [],
        fetchedAssetFileCharacters: [],
      });
    }
  }

  _checkMultiFieldChange(name, value) {
    if (name === "assetFileName") {
      this._loadassetFileCharacters();
    }
  }

  //handle single chip delete
  handleSingleChipDelete = (name, deletedChip) => {
    this.setState({
      [name]: null,
    });
  };

  //handles when dates are picked
  handleDateChange = (date, dateValue) => {
    this.setState({
      [date]: moment(dateValue).format(CommonContants.FIELD_DATE_FORMAT),
    });
  };

  //handles territories clear all button
  handleClearAllClick = (name) => {
    this.setState({
      [name]: [],
    });
  };

  //dropzone dialog close
  handleClose = (name) => {
    this.setState({ [name]: false });
  };

  handleRemoveFile(name, file) {
    if (name === "supportingFiles") {
      let supportingFilesBatch = [...this.state.supportingFilesBatch];
      supportingFilesBatch = supportingFilesBatch.filter(
        (data) => data !== file
      );
      this.setState({ supportingFilesBatch });
    } else {
      this.setState({
        files: [],
        filesBatch: null,
      });
    }
  }

  //Saving files to state for further use and closing Modal.
  async handleSave(name, newFiles, isLast = false) {
    if (name === "files") {
      this.setState({ isUploading: true });
    }
    if (name === "supportingFiles") {
      this.setState({ isUploadingSupportingFiles: true });
    }

    await NuxeoClient.instance()
      .getBatchID()
      .then((response) => {
        NuxeoClient.instance()
          .uploadFiles(newFiles, response.batchId)
          .then((response) => {
            NuxeoClient.instance()
              .getFileInfo(response.batchId)
              .then((response) => {
                if (response.code !== "201") {
                  if (name === "files") {
                    this.setState({ isUploading: false });
                  }
                  if (name === "supportingFiles" && isLast === true) {
                    this.setState({ isUploadingSupportingFiles: false });
                  }
                }
                let fileObj = {
                  name: response.fileEntries[0].name,
                  "upload-batch": response.batchId,
                  "upload-fileId": "0",
                };
                if (name === "supportingFiles") {
                  let supportingFilesBatch = [
                    ...this.state.supportingFilesBatch,
                  ];
                  supportingFilesBatch.push(fileObj);
                  this.setState({ supportingFilesBatch });
                } else if (name === "files") {
                  this.setState({ filesBatch: fileObj });
                }
              });
          });
      });
    this.setState({
      [name]: newFiles,
      [name + "Open"]: false,
    });
  }

  //handles open for dropzone
  handleOpen = (name) => {
    this.setState({ [name]: true });
  };

  handleSnackMsgClose(event) {
    this.setState({ openSnackMsg: false });
  }

  //logs all selected data once form is submitted
  async handleSubmit() {
    for (const item of this.state.requiredFields) {
      if (
        this.state[item] === null ||
        (typeof this.state[item] === "object" && this.state[item].length === 0)
      ) {
        if (item === "files") {
          this.setState({
            openSnackMsg: true,
            snackBarMsg: "Upload any one design file is required to proceed",
          });
        } else {
          let fieldName = StringUtils.toCapitalizedWords(item);
          this.setState({
            openSnackMsg: true,
            snackBarMsg: `${fieldName} is required to proceed`,
          });
        }

        return false;
      }
    }

    //submit progress indicator show
    window.scrollTo(0, 0);
    document.querySelector("body").style.overflow = "hidden";
    this.setState({ isSubmitting: true });

    var submitData = {
      licenseeName: this.state.licensee,
      contract: this.state.contract,
      territories: this.state.territories,
      property: this.state.property,
      tierOfDistribution: this.state.tierOfDistribution,
      retailer: this.state.retailer,
      consumerTarget: this.state.consumerTarget,
      marketingChannel: this.state.marketingChannel,
      onShelfDate: this.state.onShelfDate
        ? ArrayUtils.convertToISO(
            new Date(this.state.onShelfDate).toISOString()
          )
        : "",
      inMarketStartDate: this.state.inMarketStartDate
        ? ArrayUtils.convertToISO(
            new Date(this.state.inMarketStartDate).toISOString()
          )
        : "",
      inMarketEndDate: this.state.inMarketEndDate
        ? ArrayUtils.convertToISO(
            new Date(this.state.inMarketEndDate).toISOString()
          )
        : "",
      productTitle: this.state.productTitle,
      additionalNotes: this.state.additionalNotes,
      associatedJobs: this.state.associatedJobs,
      // todo: figure out what this block is doing
      licenseeRef: this.state.licenseeRef,
      productDetail: this.state.productDetail,
      assetFileName: this.state.assetFileName,
      originalAssetsUID: this.state.originalAssetsUID,
      originalAssetsParentRef: this.state.originalAssetsParentRef,
      characters: this.state.characters,
      text: this.state.text,
      isFavorite: this.state.isFavorite,
      favoriteName: this.state.favoriteName,
      wbcpContact: this.state.wbcpContact,
    };

    //merge design files and supporting files into _files
    this.uploadFiles = [];
    if (
      typeof this.state.filesBatch === "object" &&
      this.state.filesBatch !== null &&
      Object.keys(this.state.filesBatch).length > 0
    ) {
      this.uploadFiles.push(this.state.filesBatch);
    }

    if (
      typeof this.state.supportingFilesBatch === "object" &&
      this.state.supportingFilesBatch !== null &&
      Object.keys(this.state.supportingFilesBatch).length > 0
    ) {
      this.state.supportingFilesBatch.forEach((element) => {
        this.uploadFiles.push(element);
      });
    }
    let product = [
      {
        contractId: this.state.contractID,
        contractProps: this.state.propertyID,
        mkg_assetTextVerbiage: submitData.text,
        mkg_characters: this.state.charactersID,
        mkg_charactersLabel: submitData.characters,
        mkg_files: this.uploadFiles,
        mkg_inMarketDate: submitData.onShelfDate,
        // todo: figure out what this block is doing
        mkg_internalRefId: submitData.licenseeRef,
        mkg_originalAssets: submitData.originalAssetsUID,
        mkg_originalAssetsLabel: submitData.assetFileName,
        mkg_originalAssetsParentRef: submitData.originalAssetsParentRef,
        mkg_productDetail: this.state.productDetailID,
        mkg_productDetailLabel: [submitData.productDetail],
        property: this.state.propertyID,
        propertyName: [submitData.property],
        submissionType: null,
      },
    ];

    //update document
    this.document.properties["dc:description"] = submitData.productTitle;
    this.document.properties["dc:title"] = submitData.contract;
    this.document.properties["mkg_submission:deliveryTypeMkg"] =
      this.state.marketingChennalID;
    this.document.properties[this.docPrefix + "_submission:product"] = product;
    this.document.properties["mkg_submission:programBegin"] =
      submitData.inMarketStartDate;
    this.document.properties["mkg_submission:programEnd"] =
      submitData.inMarketEndDate;
    this.document.properties["mkg_submission:wbcpContact"] =
      submitData.wbcpContact;
    this.document.properties["submission:associatedJobs"] =
      this.state.associatedJobsID;
    this.document.properties["submission:consumerTarget"] =
      submitData.consumerTarget;
    this.document.properties["submission:contract"] = this.state.contractID;
    this.document.properties["submission:inMarketDate"] =
      submitData.onShelfDate;
    this.document.properties["submission:internalRefId"] =
      submitData.licenseeRef;
    this.document.properties["submission:licensee"] = this.state.licenseeID;
    this.document.properties["submission:notes"] = submitData.additionalNotes;
    this.document.properties["submission:property"] = this.state.propertyID;
    this.document.properties["submission:propertyName"] = submitData.property;
    this.document.properties["submission:retailer"] = submitData.retailer;
    this.document.properties["submission:territories"] =
      this.state.territoriesID;
    this.document.properties["submission:tierOfDistribution"] =
      submitData.tierOfDistribution;
    this.document.properties["submission:isFavorite"] = submitData.isFavorite;
    this.document.properties["submission:favoriteName"] =
      submitData.favoriteName;

    let products =
      this.document.properties[this.docPrefix + "_submission:product"];
    let productsOld = JSON.parse(JSON.stringify(products));

    this.document.name =
      this.document.name ||
      StringUtils._sanitizeName(this.document.properties["dc:title"]);
    let documentEnrichmentParams = {
      documentProperties: JSON.stringify(this.document.properties),
      docPrefix: this.docPrefix,
      propertyName: this.document.properties["submission:propertyName"],
      parentRef: this.state.licenseeID,
    };
    this.docPath =
      "/default-domain/workspaces/Submission/" + this.state.licensee;
    NuxeoClient.instance()
      .documentEnrichment(documentEnrichmentParams)
      .then((res) => {
        this.document.properties = res;
        this.document = JSON.parse(CircularJSON.stringify(this.document));
        NuxeoClient.instance()
          .submitDocument(this.docPath, this.document)
          .then((responseDoc) => {
            const jobId =
              this.document.properties["submission:workfrontProjectId"];
            ReactGA.event({
              category: "Form",
              action: "Form Submit",
              transport: "beacon",
              label: `MKG Submitted - ${this.state.property}`,
            });
            window.history.pushState({}, null, `/submit/marketing?${jobId}`);
            EventUtils.raiseEvent("success", { jobId: jobId }, this.props);
          });
      })
      .catch((error) => {
        this.document.properties[this.docPrefix + "_submission:product"] =
          productsOld;
        console.log("Error in DocumentEnrichment parsing: " + error);
        ReactGA.event({
          category: "Form",
          action: "Form Submit Error",
          transport: "beacon",
          label: `MKG Form Error - ${error}`,
        });
        alert(
          "Failed to submit job. Please try again, if problem persists please contact STARLABS.Support@warnerbros.com"
        );

        //submit progress indicator show
        this.setState({ isSubmitting: false });
      });
  }

  render() {
    const appText = this.context;
    return (
      // this.state.isLoading
      //     ? <LinearProgress/> :
      <div className="marketing-form-container">
        <Fade in={true} timeout={1500}>
          <Grid
            container={true}
            direction="column"
            spacing={4}
            alignItems="stretch"
            className="form-wrapper"
          >
            <Grid item={true} xs={12} style={{ paddingBottom: 0 }}>
              <div id="header-with-fav">
                {/* <h5 className="form-heading">Marketing</h5> */}
                <h5 className="form-heading">{appText.T9}</h5>
                <FavMenu
                  setJobInfo={this.setJobInfo}
                  licensee={this.state.licensee}
                  licenseePath={this.state.licenseePath}
                  docType={this.docType}
                  user={this.props.user}
                  handleChange={this.handleFav}
                />
              </div>
            </Grid>

            <JobLoadingModal isJobInfoLoading={this.state.isJobInfoLoading} />

            <Licensee
              handleChange={this.handleInputChange}
              value={this.state.licensee}
              fetchedData={this.state.fetchedLicensees}
            />

            <Contract
              value={this.state.contract}
              handleChange={this.handleInputChange}
              licenseeCode={this.state.licenseeCode}
            />

            {this.state.contract ? (
              <Territories
                value={this.state.territories}
                id={this.state.territoriesID}
                handleChange={this.handleInputChange}
                contractID={this.state.contractID}
              />
            ) : null}

            {this.state.contract ? (
              <Property
                value={this.state.property}
                fetchedData={this.state.fetchedProperty}
                handleChange={this.handleInputChange}
                contractID={this.state.contractID}
              />
            ) : null}

            {/* Tier of Distribution */}
            <TierOfDistribution
              handleChange={this.handleInputChange}
              value={this.state.tierOfDistribution}
            />

            {/* Enhancement: Make "retailer" optional. Add a scroll over, "if this is intended for a specific retailer then please complete". */}
            <Retailer
              handleChange={this.handleInputChange}
              value={this.state.retailer}
            />

            {/* Enhancement: make consumer target optional */}
            <ConsumerTarget
              handleChange={this.handleInputChange}
              value={this.state.consumerTarget}
            />

            <Tooltip
              placement="top-start"
              // title="Please enter the date the product being marketed will enter the market"
              title={appText.T275}
            >
              <Grid item={true} xs={12}>
                <div>
                  <InputLabel className="field-label field-datePicker">
                    {/* Product On-shelf Date */}
                    {appText.T252}
                  </InputLabel>
                  {/* <DatePicker
                    InputProps={{ disableUnderline: true }}
                    fullWidth={true}
                    placeholder="MM/DD/YYYY"
                    value={this.state.onShelfDate}
                    onChange={(date) =>
                      this.handleDateChange("onShelfDate", date)
                    }
                    format={CommonContants.FIELD_DATE_FORMAT}
                  ></DatePicker> */}

                  {this.state.browserLang === "ja-JP" ? (
                    <DatePicker
                      fullWidth={true}
                      placeholder="YYYY-MM-DD"
                      value={this.state.onShelfDate}
                      onChange={(date) =>
                        this.handleDateChange("onShelfDate", date)
                      }
                      format={"YYYY-MM-DD"}
                    ></DatePicker>
                  ) : (
                    <DatePicker
                      fullWidth={true}
                      placeholder="MM/DD/YYYY"
                      value={this.state.onShelfDate}
                      onChange={(date) =>
                        this.handleDateChange("onShelfDate", date)
                      }
                      format={CommonContants.FIELD_DATE_FORMAT}
                    ></DatePicker>
                  )}
                </div>
              </Grid>
            </Tooltip>

            <Channel
              value={this.state.marketingChannel}
              fetchedData={this.state.fetchedMarketingChannels}
              handleChange={this.handleInputChange}
            />

            <Tooltip
              placement="top-start"
              // title="Please enter the date the marketing will go live"
              title={appText.T277}
            >
              <Grid item={true} xs={12}>
                <InputLabel className="field-label field-datePicker" required>
                  {/* Marketing Start Date */}
                  {appText.T256}
                </InputLabel>
                {/* <DatePicker
                  InputProps={{ disableUnderline: true }}
                  fullWidth={true}
                  placeholder="MM/DD/YYYY"
                  value={this.state.inMarketStartDate}
                  onChange={(date) =>
                    this.handleDateChange("inMarketStartDate", date)
                  }
                  format={CommonContants.FIELD_DATE_FORMAT}
                /> */}
                {this.state.browserLang === "ja-JP" ? (
                  <DatePicker
                    InputProps={{ disableUnderline: true }}
                    fullWidth={true}
                    placeholder="YYYY-MM-DD"
                    value={this.state.inMarketStartDate}
                    onChange={(date) =>
                      this.handleDateChange("inMarketStartDate", date)
                    }
                    format={"YYYY-MM-DD"}
                  ></DatePicker>
                ) : (
                  <DatePicker
                    InputProps={{ disableUnderline: true }}
                    fullWidth={true}
                    placeholder="MM/DD/YYYY"
                    value={this.state.inMarketStartDate}
                    onChange={(date) =>
                      this.handleDateChange("inMarketStartDate", date)
                    }
                    format={CommonContants.FIELD_DATE_FORMAT}
                  ></DatePicker>
                )}
              </Grid>
            </Tooltip>

            <Tooltip
              placement="top-start"
              // title="Please enter the date, if applicable, the marketing will end"
              title={appText.T278}
            >
              <Grid item={true} xs={12}>
                <InputLabel className="field-label field-datePicker">
                  {/* Marketing End Date */}
                  {appText.T259}
                </InputLabel>
                {this.state.browserLang === "ja-JP" ? (
                  <DatePicker
                    InputProps={{ disableUnderline: true }}
                    fullWidth={true}
                    placeholder="YYYY-MM-DD"
                    value={this.state.inMarketEndDate}
                    onChange={(date) =>
                      this.handleDateChange("inMarketEndDate", date)
                    }
                    format={"YYYY-MM-DD"}
                  ></DatePicker>
                ) : (
                  <DatePicker
                    InputProps={{ disableUnderline: true }}
                    fullWidth={true}
                    placeholder="MM/DD/YYYY"
                    value={this.state.inMarketEndDate}
                    onChange={(date) =>
                      this.handleDateChange("inMarketEndDate", date)
                    }
                    format={CommonContants.FIELD_DATE_FORMAT}
                  ></DatePicker>
                )}
              </Grid>
            </Tooltip>

            {/*  Enhancement: Change "project description" to "project title" - need to confi
             *  rm the character limitations*/}
            <Tooltip
              placement="top-start"
              // title="Please enter a title for this marketing submission. E.G.; “Paid ads for our retail partner’s website” or “Influencer campaign for Back to School”"
              title={appText.T279}
            >
              <Grid item={true} xs={12}>
                <InputLabel className="field-label field-text">
                  {/* Campaign Title */}
                  {appText.T262}
                </InputLabel>
                <TextareaAutosize
                  aria-label="minimum height"
                  rows={1}
                  className="textArea-field"
                  value={this.state.productTitle}
                  onChange={this.handleChange("productTitle")}
                />
              </Grid>
            </Tooltip>

            <Tooltip
              placement="top-start"
              // title="Please provide additional context/notes about this submission for the marketing team’s review"
              title={appText.T280}
            >
              <Grid item={true} xs={12}>
                <InputLabel className="field-label field-text" required>
                  {/* Context/Additional Notes */}
                  {appText.T263}
                </InputLabel>
                <TextareaAutosize
                  aria-label="minimum height"
                  rows={1}
                  className="textArea-field"
                  value={this.state.additionalNotes}
                  onChange={this.handleChange("additionalNotes")}
                />
              </Grid>
            </Tooltip>

            <AssociatedJobs
              handleChange={this.handleInputChange}
              value={this.state.associatedJobs}
              id={this.state.associatedJobsID}
            />

            <Tooltip
              placement="top-start"
              // title="Please include the applicable Licensee Reference"
              title={appText.T281}
            >
              <Grid item={true} xs={12}>
                <InputLabel className="field-label field-text">
                  {/* Licensee Ref # */}
                  {appText.T106}
                </InputLabel>
                <TextField
                  id="LicenseeRef"
                  fullWidth={true}
                  value={this.state.licenseeRef}
                  InputProps={{ disableUnderline: true }}
                  onChange={this.handleChange("licenseeRef")}
                />
              </Grid>
            </Tooltip>

            <Tooltip
              placement="top-start"
              // title="Who is your primary WBCP Business Contact?"
              title={appText.T282}
            >
              <Grid item={true} xs={12}>
                <InputLabel className="field-label field-text" required>
                  {/* Who is your primary WBCP Business Contact? */}
                  {appText.T266}
                </InputLabel>
                <TextField
                  id="wbcpContact"
                  fullWidth={true}
                  value={this.state.wbcpContact}
                  InputProps={{ disableUnderline: true }}
                  onChange={this.handleChange("wbcpContact")}
                />
              </Grid>
            </Tooltip>

            {this.state.property ? (
              <ProductDetail
                contractID={this.state.contractID}
                value={this.state.productDetail}
                handleChange={this.handleInputChange}
                type={""}
              />
            ) : null}

            {this.state.property ? (
              <AssetFileName
                isRequired={true}
                parentRef={this.state.originalAssetsParentRef}
                value={this.state.assetFileName}
                id={this.state.originalAssetsUID}
                handleChange={this.handleAssets}
                fetchedLicensees={this.state.fetchedLicensees}
                fetchedProperty={this.state.fetchedProperty}
              />
            ) : null}

            {this.state.property ? (
              <Characters
                value={this.state.characters}
                id={this.state.charactersID}
                propertyID={this.state.propertyID}
                handleChange={this.handleInputChange}
                type={this.props.type}
              />
            ) : null}

            <Tooltip
              placement="top-start"
              // title="Please include any relevant T&V from product for this submission"
              title={appText.T285}
            >
              <Grid item={true} xs={12}>
                <InputLabel className="field-label field-text">
                  {/* Text/Verbiage on Product */}
                  {appText.T88}
                </InputLabel>
                <TextareaAutosize
                  aria-label="minimum height"
                  rows={1}
                  value={this.state.text}
                  className="textArea-field"
                  onChange={this.handleChange("text")}
                />
              </Grid>
            </Tooltip>

            <Grid item={true} xs={12} style={{ paddingBottom: 0 }}>
              <div id="header-with-fav">
                <h8 className="legal-line">
                  {/* Please ensure legal line is visible. */}
                  {appText.T269}
                </h8>
              </div>
            </Grid>

            {/* <Grid
                            justify="space-between"
                            container
                            spacing={10}
                            direction="column"
                            alignItems="flex-start"
                            className="form-wrapper">
                            <Grid item={true}> */}

            <table className="file-upload-container-mk">
              <th id="design-file-mkt">
                <Button
                  variant="outlined"
                  onClick={() => this.handleOpen("filesOpen")}
                >
                  {/* Upload Design */}
                  {appText.T270}
                </Button>
                <div style={{ width: "100%" }}>
                  <Loads hidden={!this.state.isUploading}></Loads>
                </div>
                <DropzoneDialog
                  open={this.state.filesOpen}
                  onSave={(files) => this.handleSave("files", files)}
                  showPreviews={true}
                  showFileNames={true}
                  acceptedFiles={["audio/*, image/*, video/*", "application/*"]}
                  filesLimit={1}
                  maxFileSize={5000000000}
                  onClose={() => this.handleClose("filesOpen")}
                />
                {this.state.files.map((item, id) => {
                  return (
                    <div
                      style={{
                        display: this.state.isUploading ? "none" : "flex",
                      }}
                      key={id}
                      className="file-uploaded"
                    >
                      <span className="file-name">{item.name}</span>
                      <div className="check-circle-icon">
                        <Tooltip title="Done">
                          <CheckCircleIcon />
                        </Tooltip>
                      </div>
                      <div
                        className="trash-icon"
                        onClick={() => this.handleRemoveFile("files")}
                      >
                        <Tooltip title={appText.T287}>
                          <DeleteIcon />
                        </Tooltip>
                      </div>
                    </div>
                  );
                })}
              </th>
              <th
                id="design-file-mkt"
                style={{
                  paddingLeft: "5%",
                  // paddingRight: '5%'
                }}
              >
                <Button
                  variant="outlined"
                  onClick={() => this.handleOpen("supportingFilesOpen")}
                >
                  {/* Upload Supporting Material */}
                  {appText.T271}
                </Button>
                <div style={{ width: "100%" }}>
                  <Loads
                    hidden={!this.state.isUploadingSupportingFiles}
                  ></Loads>
                </div>
                {/* TODO: What other file types should be accepted? */}
                {/* Where do these files get uploaded to? */}
                <DropzoneDialog
                  open={this.state.supportingFilesOpen}
                  onSave={(files) => {
                    files.forEach((file, index) => {
                      var array = [];
                      array.push(file);
                      if (index === files.length - 1) {
                        this.handleSave("supportingFiles", array, true);
                      } else {
                        this.handleSave("supportingFiles", array);
                      }
                      array.slice(0, 1);
                    });
                    ReactGA.event({
                      category: "Form",
                      action: "Supporting Materials Uploaded",
                      transport: "beacon",
                      label: `Uploaded - ${files.length} Supporting Materials`,
                    });
                    this.handleClose("supportingFilesOpen");
                  }}
                  showPreviews={true}
                  showFileNames={true}
                  maxFileSize={5000000000}
                  acceptedFiles={["audio/*, image/*, video/*", "application/*"]}
                  filesLimit={20}
                  onClose={() => this.handleClose("supportingFilesOpen")}
                />
                {this.state.supportingFilesBatch.map((item, id) => {
                  return (
                    <div
                      style={{
                        display: this.state.isUploadingSupportingFiles
                          ? "none"
                          : "flex",
                      }}
                      key={id}
                      className="file-uploaded"
                    >
                      <span className="file-name">{item.name}</span>
                      <div className="check-circle-icon">
                        <Tooltip title="Done">
                          <CheckCircleIcon />
                        </Tooltip>
                      </div>
                      <div
                        className="trash-icon"
                        onClick={() =>
                          this.handleRemoveFile("supportingFiles", item)
                        }
                      >
                        <Tooltip title={appText.T287}>
                          <DeleteIcon />
                        </Tooltip>
                      </div>
                    </div>
                  );
                })}
              </th>
            </table>
            {/* </Grid>
                        </Grid> */}
            <Grid item={true} xs={12} style={{ paddingBottom: 0 }}>
              <h8>
                <b>
                  {/* <u>Please Note:</u> */}
                  <u>{appText.T272}</u>
                </b>
              </h8>
              {/* <div>
                Marketing Design File uploads are limited to only <b>1</b> file.
                Supporting Materials are limited to <b>20</b> files.
              </div> */}
              <div>
                {appText.T273 &&
                  appText.T273.split(/(1|20)/).map((text, index) => {
                    if (text === "1") {
                      return <b key={index}>1</b>;
                    }
                    if (text === "20") {
                      return <b key={index}>20</b>;
                    }
                    return text;
                  })}
              </div>
            </Grid>
            <Grid item={true} xs={12}>
              {/* <Button>Cancel</Button> */}
              <Button
                variant="outlined"
                className="btn"
                disabled={
                  !this.state.showSubmit ||
                  this.state.isUploading ||
                  this.state.isUploadingSupportingFiles
                }
                onClick={this.handleSubmit}
                type="submit"
                value="Submit"
              >
                {appText.T274}
              </Button>
            </Grid>
            <Loading hidden={!this.state.isSubmitting}></Loading>
            <div className="snack-bar-container">
              <Snackbar
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "right",
                }}
                open={this.state.openSnackMsg}
                onClose={this.handleSnackMsgClose}
                autoHideDuration={6000}
                ContentProps={{
                  "aria-describedby": "snack-bar-msg",
                }}
                message={
                  <div className="snack-bar-msg-content">
                    <span className="snack-bar-msg-icon">
                      <InfoIcon></InfoIcon>
                    </span>
                    <span className="snack-bar-msg">
                      {this.state.snackBarMsg}
                    </span>
                  </div>
                }
                action={[
                  <IconButton
                    key="close"
                    aria-label="close"
                    color="inherit"
                    className="snack-msg-close-icon"
                    onClick={this.handleSnackMsgClose}
                  >
                    <CloseIcon />
                  </IconButton>,
                ]}
              />
            </div>
          </Grid>
        </Fade>
      </div>
    );
  }
}

export default MarketingSubmissionFields3;
